export default {
  routes: {
    home: "Hem",
    login: "Login",
    register: "Registrera",
    logout: "Logout",

    company: "Företag",
    dashboard: "Dashboard",
    application: "Applikationer",
    alarm: "Larmhantering",

    user: "Användare",
    tagdata: "Data",
    tag: "Sensorer",
    script: "Script-motor",
    report: "Rapport",
    contact: "Kontakt",
    apiRef: "API-Dokumentation",
    shop: "Köp sensorer",
    manual: "Manual",

    userEdit: "Konto",

    superadmin: "Admin"
  },


  landing: {
    slogan: "VIZUALIZATION MADE EASY",
    or: "ELLER",
    key: {
      title: "Funktioner",
      1: "Sensorhantering",
      2: "Visualisering",
      3: "Flera Dashboards",
      4: "Alarm hantering",
      5: "Personal hantering",
      6: "Script engine",

      description: {
        1: "Hantera sensorer för data hangering.",
        2: "Få din sensor data visualiserad på det sättet du vill se din information.",
        3: "Skapa egna dashboards för ditt användningsområde.",
        4: "Alarm hantering för kritiska användningsområden.",
        5: "Hantera användarkonton för ditt företag.",
        6: "Avancerade användare kan skapa script för att manipulera data."
      }
    },

    usecases: {
      title: "Applikation",
      1: "Miljösensorer",
      2: "Elsensorer",
      3: "Rörelsesensorer",
      4: "Temperatursensor",

      description: {
        1: "SENSORONLINE passar otroligt bra för smarta jordbruks lösningar så som de på Ljusgårda redan bygger.",
        12: "Läs mer om Ljusgårda.",
        2: "Mät ström för gatulycktor i din stad. Med script+engine kan du göra så att datan blir lätt att tyda.",
        3: "Mät hur många människor som kommer och går från din anläggning.",
        4: "Självklart är tempratur visualizering en nyckel för SENSORONLINE platformen. Företag väljer att mäta och hantera sina tempraturer med SENSORONLINE."
      }
    },

    help: {
      title: "KONTAKTA OSS",

      sensors: {
        title: "Behöver du några nya sensorer?",
        description: "Om du behöver hjälp med att lösa ett problem eller få mer kontroll på dina tillgångar. Eller hur du kan visualizera dina sensorer på ett sätt som underlättar för din verksamhet. Tveka inte på att höra av dig till oss för att hjälpa. \n Du kan kolla vårt portfolio av ",
        store: "sensorer som vi säljer hos IoT AB."
      },

      api: {
        title: "Använd vårt API",
        description: "Du kan givetvis använda vårat API för att sätta in data eller hämta data från och till befintliga system. "
      },

      contact: {
        title: "Är du intresserad? Ta kontakt!",
        siencepark: "Skövde Sience Park",
        address: "Kaplansgatan 16B",
        postal: "521 32 Skövde",
        country: "Sverige",
        phoneTitle: "Telefon",
        phonenumber: "+46 (0) 500 600 022",
        phonenumber2: "+46 (0) 733 165 100",
        emailTitle: "Email",
        email: "info@sensor-online.se"
      }
    }
  },


  imageMap: {
    chooseTag: "Välj sensor"
  },

  log: {
    type: {
      sms: "SMS",
      app: "Applikation",
      warning: "Varning",
      error: "Error",
      userevent: "Userevent",
      login: "Login"
    },

    logTable: {
      title: "Logg"
    },

    activeAlarms: {
      title: "Aktiva larm"
    },

    activeUsersTable: {
      title: "Inloggade användare"
    },

    fields: {
      type: "Typ",
      user: "Användare",
      message: "Meddelande",
      createdAt: "Skapad",

      status: "Status",
      lastAction: "Event",
      lastSeen: "Timestamp",

      alarm: {
        name: "Namn",
        value: "Värde",
        messageSent: "Skickat notifikation"
      }
    }
  },

  common: {
    timestamp: "Tidsstempel",
    lang: "Språk",
    error: "Ett fel uppstod försökigen senare",
    edit: "Redigera",
    delete: "Tabort",
    purge: "Radera",
    submit: "Skicka",
    create: "Skapa",
    update: "Uppdatera",
    get: "Hämta",

    search: "Sök",
    close: "Stäng",

    login: "Logga in",
    register: "Registrera dig",
    email: "Email",
    password: "Lösenord",
    confirmPassword: "Upprepa lösenord",
    newPassword: "Nytt lösenord",
    forgotPassword: "Glömt lösenord",

    createdAt: "Skapad",
    updatedAt: "Updaterad",

    save: "Spara",
    show: "Visa",
    updated: "Updaterad",
    created: "Skapad",
    deleted: "Raderad",
    back: "Tillbaka",
    send: "Skicka",

    add: "Lägg till",

    settings: "Inställningar",

    noTagOrAppChoosen: "Sensor och/eller Applikation saknas",
    noDataFound: "Ingen data funnen",
    darkTheme: "Mörkt tema",

    active: "Aktiv",
    notActive: "Inte Aktiv",

    sent: "Skickat",
    notSent: "Inte Skickat",

    loginOrRegister: "Logga in eller registrera dig",

    or: "Eller",

    dashboard: "Gå till Dashboard",

    copy: "Kopiera",
    disagree: "Nej",
    verify: "Är du säker att du vill fortsätta?",
    accept: "Ja",

    days: {
      monday: "Måndag",
      tuesday: "Tisdag",
      wednesday: "Onsdag",
      thursday: "Torsdag",
      friday: "Fredag",
      saturday: "Lördag",
      sunday: "Söndag"
    }
  },

  map: {
    setPosFormTitle: "Välj sensor för position"
  },

  dashboard: {
    name: "Dashboards",
    copyDeleteTitle: "Tabort eller kopiera dashboard",
    createTitle: "Eller skapa ett nytt dashboard",
    chooseTitle: "Välj dashboard",
    chooseDesc:
      "Det valet du väljer här kommer att sparas till nästa gång du använder portalen. För att ändra eller skapa en ny efteråt tryck på den blåa knappen nere i högra hörnet.",

    fields: { name: "Namn" },
    nameReq: "Detta fältet måste vara ifyllt"
  },
  module: {
    create: "Skapa ett nytt element",
    edit: "Redigera elementet",
    metas: "Attributer",

    meta: {
      label: "Attributer",
      save: "Spara attribut",

      valueMatch: "Attribut 1",
      value: "Attribut 2",
      key: "Nyckel",
      icon: "Ikon",

      keys: {
        value_match: "Namn för värde",
        icon: "Ikon sufix",
        sufix: "Sufix",
        prefix: "Prefix",
        deveui: "Deveui",
        maxheight: "Max höjd"
      },

      fields: {
        value_match: "Matchande värde",
        name: "Text",
        icon: "Ikon sufix",
        sufix: "Sufix",
        prefix: "Prefix",
        deveui: "Deveui",
        maxheight: "Max höjd (ex 300 för 300px)"
      }
    },

    fields: {
      title: "Titel",
      types: "Typ",
      content: "Content",
      sm: "Storlek liten skärm",
      md: "Storlek medel skärm",
      min: "Min värde",
      max: "Max värde",
      image: "Bild",
      url: "URL"
    },
    enum: {
      size: { xs: "XSMALL", sm: "SMALL", md: "MEDIUM", lg: "LARGE" },
      types: {
        0: "Chart",
        1: "Gauge",
        2: "Text",
        3: "Bild",
        4: "Karta",
        5: "Företagsinformation",
        6: "IFrame",
        7: "SMHI",
        8: "Senaste värdet",
        9: "Raw tabell",
        10: "Multiline Chart",
        11: "Bild karta"
      }
    }
  },

  weather: {
    title: "SMHI Väderdata",
    icon: "Väder",
    temp: "Tempratur",
    windDir: "Vindriktning",
    windSpeed: "Vind",
    humidity: "Fukt",
    thunder: "Åska",
    date: "Datum",
    precipitation: "Nedebörd"
  },

  contact: {
    title: "Kontakta oss",
    descriptionTitle: "Sensor-Online",
    description:
      "Vi på SensorOnline vet att det kan vara svårt att komma igång med dina sensorer. Tveka inte på att kontakta oss vid frågor eller rådgivning.",
    emailTitle: "Email",
    email: "info@sensor-online.se",
    phoneTitle: "Telefon",
    phoneOne: "+46 (0) 500 6000 22",
    phoneTwo: "+46 (0) 733 165 100",
    locationSiencepark: "Skövde Science Park",
    locationStreet: "Kaplansgatan 16B",
    locationPostalcode: "521 32 Skövde",
    locationCountry: "Sweden"
  },

  company: {
    name: "Företag",
    orgNumber: "Org-nummer",

    companyInfo: "Företags information",

    addUser: "Lägg till användare",

    invite: "Bjud in en användare",
    inviteSent: "Inbjudan skickad",
    inviteFailed:
      "Kunde inte hitta användaren. Se till att användaren är registrerad och inte tillhör ett företag redan!",

    fields: {
      name: "Företagsnamn",
      orgNumber: "Org-nummer",
      postalAdress: "Postadress",
      deliveryAdress: "Leveransadress",
      contactPhonenumber: "Kontakt telefonnummer",
      invoiceAdress: "Epost för faktura",
      refrenceNmuber: "Referensnummer",
      image: "Företags logotyp"
    },

    validation: {
      nameRequired: "Du måste fylla i Företagsnamn",
      nameMax: "Företagsnamn kan högst vara 255 karaktärer",

      orgNumberRequired: "Du måste fylla i Org-nummer",
      orgNumberFormatError: "Fel format på Org-nummer",

      emailRequired: "Du måste fylla i Email",
      emailFormatError: "Ange giltig Email address",

      passwordMissmatch: "Lösenorden matchar inte"
    }
  },

  report: {
    title: "Rapporter",
    refrenceDateDesc:
      "Referens dagen är den dagen som refereras till vid utskick av rapport, om intervalen är månadsvis väljer du dagen som den ska skickas på(1a varje månad tillexempel). Eller veckovis (vilken dag mån - fre som rapporten ska skickas ut).",
    create: "Skapa Rapport prenumeration",
    update: "Uppdatera Rapport prenumeration",
    exportDownload: "Raport nedladdning",
    export: "Exportera",
    downloadFailed: "Det gick inte att hämta rapporten försök igen senare.",
    fields: {
      name: "Rapport Namn",
      tempo: "Interval",
      createdAt: "Skapad",
      updatedAt: "Uppdaterad",
      id: "ID",
      refrenceDate: "Referens dag",
      reportContacts: "Rapport kontakter",
      lastSent: "Senast skickade"
    },

    tempo: {
      desc: {
        0: "Skickas varje dag med rapport för dagen.",
        1: "Skickas varje måndag med rapport för veckan innan.",
        2: "Skickas 1a varje månad med rapport för månaden innan."
      },

      0: "Dagligen",
      1: "Veckovis",
      2: "Månadsvis"
    }
  },

  script: {
    name: "Scripts",
    create: "Skapa nytt Script",
    tagsTitle: "Sensor ID och Nycklar",
    placeHolderContent: `   // Convert the temprature to fahrenheit 
    var tempToFahrenheit = tags["INSERT-DEVEUI"].Read("INSERT-KEY") *  9/5 + 32;
    
    // Write the new value to a new key
    tags["INSERT-DEVEUI"].Write("INSERT-NEW-KEY", tempToFahrenheit);`,
    examples: "Exempel",
    helpTitle: "Exempel och hjälp",
    exampleFarenheitTitle: "Exempel: Omvandla Celcius till Farenheit",
    exampleAverageTitle: "Exempel: Medelvärde",
    exampleAverage: `   // Get the data from three sensors
    var temp1 = tags["INSERT-DEVEUI"].Read("extTemp");
    var temp2 = tags["INSERT-DEVEUI"].Read("extTemp");
    var temp3 = tags["INSERT-DEVEUI"].Read("extTemp");

    // Write the new value to a new key
    tags["INSERT-DEVEUI"].Write("averageTemp", (temp1 + temp2 + temp3) / 3);`,
    exampleBlackIceTitle: "Exempel: Blackice detection",
    exampleBlackIce: `   var uteTemp = tags["A81758FFFE0459FB"].Read("temperature");
    var fukt = tags["A81758FFFE0459FB"].Read("humidity");
    var vagTemp = tags["A81758FFFE0459FA"].Read("temperature");

    // Set the conditions of blackice
    if (vagTemp < 2 && fukt > 75 && uteTemp > 3) {
      tags["A81758FFFE0459FA"].Write("black_ice", 1);
    } else {
      tags["A81758FFFE0459FA"].Write("black_ice", 0);
    }`,

    example420Title: "Exempel: 4-20mA korrigering",
    example420: `   // Convert the analog input value 4-20mA to the right scale
    var LowValue = 0;
    var HighValue = 200;
    var InputValue = tags["INSERT-DEVEUI"].Read("AnalogIn");

    var result = (((HighValue-LowValue)/(20 - 4)) * (InputValue - 4)) + LowValue;

    // Write the new calculated value to a new key
    tags["INSERT-DEVEUI"].Write("ActualValue", result);
     `,

    example010Title: "Exempel: 0-10V korrigering",
    example010: `   // Convert the analog input value 4-20mA to the right scale
    var LowLimit = 0;
    var HighLimit = 200;
    var InputValue = tags["INSERT-DEVEUI"].Read("AnalogIn");
    var result = (HighLimit – LowLimit) x (InputValue / 10) + LowLimit;

    tags["INSERT-DEVEUI"].Write("AnalogInCorrected", result);
    `,
    exampleMCF88Title: "Downlink för MCF88 relä",
    exampleMCF88: `downlinks.MCF88("INSERT-DEVEUI", false (or) true, "gotthardp")`,

    type: {
      0: "Loopat Script",
      1: "Anropat Script",
      2: "Triggat Script"
    },

    fields: {
      name: "Namn",
      type: "Typ",
      interval: "Interval",
      lastRun: "Senaste körning"
    },

    validation: {
      intervalRequired: "Detta fält måste vara ifyllt",
      intervalMinValue: "Det minsta värdet för Interval är 0"
    }
  },

  user: {
    name: "Användare",

    email: "Email",
    role: "Roll",

    userInfo: "Personliga uppgifter",

    loginFailed: "Inloggning misslyckades",
    signInFailed: "Email/lösenord matchar inte försök igen",
    loginSuccessful: "Inloggad",
    updateFailed: "Uppdateringen misslyckades",
    edit: "Redigera",
    forgotPassword: "Glömt lösenord?",

    fields: {
      firstName: "Förnamn",
      lastName: "Efternamn",
      phoneNumber: "Telefonnummer",
      email: "Email",
      password: "Lösenord"
    }
  },

  application: {
    name: "Applikation | Applikationer",
    noCompanyError: "För att skapa en Applikation måste du ha ett företag",
    validation: {
      nameRequired: "Din applikation måste ha ett namn",
      nameMax: "Namn kan högst vara 255 karaktärer"
    },
    fields: {
      id: "ID",
      name: "Namn",
      createdAt: "Skapad"
    }
  },

  alarm: {
    name: "Larm",
    create: "Lägg till nytt larm",
    affirmation: "Bekräfta",

    activeAlarm: "Alarm Varningar",

    priority: {
      desc: {
        a: "Skickar både email och sms",
        b: "Skickar endast sms",
        c: "Skickar endast email"
      }
    },

    fields: {
      id: "ID",
      name: "Namn",
      priority: "Prioritet",
      alarmDelay: "Fördröjning innan larm",
      active: "Larmstatus",
      tagDataKey: "Nyckel",
      tag: "Sensor",
      message: "Larm meddelande",
      limitHigh: "Hög larmgräns",
      limitLow: "Låg larmgräns",
      contactType: "Kontakttyp",
      alarmContacts: "Alarm kontakter",
      activeDays: "Aktiva dagar",
      limit: "Låg och Hög larmgräns",
      activeAlarms: "Larm Varningar",
      messageSent: "Skickat meddelande"
    },

    validation: {
      nameRequired: "Detta fält måste vara ifyllt",
      max: "Max gränsen är 255"
    }
  },

  batteryStatus: {
    levels: "Batterinivåer",
    value: "Värde",
    lastSeen: "Senaste värdet",
    label: "Batteri Volt"
  },

  tagdata: {
    name: "Data",
    amount: "Antal datapunkter:",
    notation: "{0} st",
    latestactivity: "Senaste aktivitet",
    latestvalue: "Senaste värdet",
    defaultKey: "Standard nyckel",

    fields: {
      id: "ID",
      name: "Namn",
      key: "Nyckel",
      value: "Värde",
      createdAt: "Skapad"
    }
  },

  tag: {
    chooseDecoder: "Välj en decoder",
    decoder: "Decoder",
    name: "Sensorer",
    amount: "Antal sensorer:",
    notation: "{0} st",
    details: "Sensor detaljer",
    removeImage: "Tabort bild",
    chooseKey: "Välj nyckel",
    saveKeyAsDefault: "Standard",

    tagPool: {
      tagPool: "Sensor-pool",
      deveui: "Deveui",
      createdAt: "Created",
      hide: "Göm från lista",
      take: "Lägg till sensor",
      show: "Visa i listan",
      hiddenTags: "Gömda sensorer"
    },

    fields: {
      id: "ID",
      name: "Namn",
      deveui: "DevEUI",
      appKey: "AppKey",
      appEui: "AppEUI",
      applicationId: "Applikation",
      profile: "Profil",
      lat: "Latitude",
      long: "Longitude",
      latAndLng: "Latitude och Longitude",
      image: "Bild på installation"
    }
  },

  validation: {
    required: "{0} måste vara ifylld",
    max: "{0} får max vara {1} karaktärer",
    requiredSingle: "Detta fält måste vara ifyllt",
    toLong: "Detta fält överstiger maxlängd",
    contryCodeError:
      "Glöm inte att telefonnummret måste ha en landskod (ex 4607xxxxxxxx)",

    passwordMissmatch: "Lösenorden matchar inte"
  },

  warning: {
    amount: "Aktiva Larm:",
    notation: "{0} st"
  }
};
